import { useEffect } from "react";
import { ProjetoPersonalizado } from "src/components/projetos/personalizados";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Projeto personalizado";

const ProjetosPersonalizadosPage = () => {

  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetoPersonalizado />
        </div>
      </div>
    </div>
  );
};

export { ProjetosPersonalizadosPage };
